import { CLOUD_INTEGRATIONS } from "./types";

const CLOUD_INTEGRATION_URL_PATHS: Partial<Record<CLOUD_INTEGRATIONS, string>> = {
  [CLOUD_INTEGRATIONS.AWS]: "aws",
  [CLOUD_INTEGRATIONS.Azure]: "azure",
};

export const getCloudIntegrationUrl = (
  type: CLOUD_INTEGRATIONS.AWS | CLOUD_INTEGRATIONS.Azure,
  integrationId: string
): string => {
  return `/integrations/${CLOUD_INTEGRATION_URL_PATHS[type]}/${integrationId}`;
};
